export const iconFontAwesomeEnergyRadiation = (
	<i className="fa-solid fa-radiation"></i>
);
